import { render, staticRenderFns } from "./SocialMediaModal.vue?vue&type=template&id=4af2f15c&"
import script from "./SocialMediaModal.vue?vue&type=script&lang=js&"
export * from "./SocialMediaModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports